import React, { useEffect, useState } from 'react';

export default function RequestProgress({ label = 'Yanıt hazırlanıyor…' }) {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const started = Date.now();
    const timer = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="chat-thinking" role="status" aria-live="polite">
    <span>{seconds >= 35 ? 'Yanıt beklenenden uzun sürüyor; işlem sürerken taslağını yazabilirsin.' : label}</span>
    {seconds >= 10 && <span aria-hidden="true"> · {seconds} sn</span>}
    {seconds >= 15 && seconds < 35 && <span> Çalışman korunuyor; yeniden göndermene gerek yok.</span>}
  </div>;
}
